// Arms or disarms the order-summary fee breakdown (desktop + mobile) that the server
// renders inert while the fee is pending. Only overviews rendered with an explicit
// enabled value are touched, so already-priced summaries keep their own state.
export function setCheckoutFeeBreakdownEnabled(enabled) {
  document
    .querySelectorAll('[data-controller~="order-summary"][data-order-summary-enabled-value]')
    .forEach((el) => {
      el.dataset.orderSummaryEnabledValue = String(enabled);
    });
}

export function setCheckoutBreakdownTotal(totalDisplay) {
  const display = (totalDisplay || "").trim();
  if (!display) return;
  document.querySelectorAll(".js-checkout-breakdown-total").forEach((el) => {
    el.textContent = display;
  });
}
